export function splitCSVRow(row: string): string[] {
  const result: string[] = [];
  let current = '';
  let inQuotes = false;

  for (let i = 0; i < row.length; i++) {
    const ch = row[i];
    if (ch === '"') {
      if (inQuotes && i + 1 < row.length && row[i + 1] === '"') {
        current += '"';
        i++;
      } else {
        inQuotes = !inQuotes;
      }
    } else if (ch === ',' && !inQuotes) {
      result.push(current.trim());
      current = '';
    } else {
      current += ch;
    }
  }
  result.push(current.trim());
  return result;
}

export function parseCSVLines(text: string): string[][] {
  const lines: string[][] = [];
  const rows = text.split(/\r?\n/);

  for (const row of rows) {
    const trimmed = row.trim();
    if (trimmed.length === 0) continue;
    lines.push(splitCSVRow(trimmed));
  }

  return lines;
}